export function getStoredToken() {
  return localStorage.getItem('timeLockToken');
}

export function getAuthConfig(config = {}) {
  const token = getStoredToken();
  if (!token) {
    return config;
  }

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  };
}
